import { HttpContextToken } from '@angular/common/http';

export interface RetryConfig {
  attempts: number;
  baseMs: number; // base delay in ms
  maxDelayMs?: number;
  retryMethods?: string[]; // e.g. ['GET','HEAD']
  retryStatuses?: (number | string)[]; // e.g. [0, 408, 'ECONNRESET']
  // Optional explicit delay multipliers per attempt, e.g. [1, 4, 8]
  // When provided, delays = baseMs * multipliers[attemptIndex]
  multipliers?: number[];
}

// Per-request config for retry; defaults provided here
export const RETRY_CONFIG = new HttpContextToken<RetryConfig>(() => ({
  attempts: 3,
  // Set base to 1s and custom multipliers for 1s, 4s, 10s schedule
  baseMs: 1000,
  maxDelayMs: 10000,
  // Include POST because many APIs use POST for read queries (idempotent)
  // Opt-out per request with NO_GLOBAL_RETRY or override retryMethods in context
  retryMethods: ['GET', 'HEAD', 'POST'],
  retryStatuses: [0, 400, 408, 429, 500, 502, 503, 504], // 0 = network error, 400 added per user request
  multipliers: [1, 4, 10],
}));

// Opt-out of global retry
export const NO_GLOBAL_RETRY = new HttpContextToken<boolean>(() => false);

// Opt-out of global error toast
export const NO_ERROR_TOAST = new HttpContextToken<boolean>(() => false);
